<template>
    <div class="hidden lg:block px-4 text-2xl tracking-wider lg:h-full lg:overflow-auto">
      <div
        v-for="(item, index) in updates.text"
        :key="index"
        class="py-8 px-4 border-b border-black last:border-0"
      >
        <h1 :class="{ blinker: index == 0 }">{{ item.title }}</h1>
        <div v-html="item.text"></div>
      </div>
    </div>
</template>

<script>
export default {
  created() {
    if (!this.$store.state.updates.title) this.$store.dispatch("loadUpdates");
  },
  computed: {
    updates() {
      return this.$store.state.updates;
    },
  },
};
</script>
